import { api } from './index';

function basePath(patientId: number): string {
  return `/api/internal/patients/${patientId}/service_assignments`;
}

export type PatientServiceAssignment = {
  id: number;
  startsOn: string;
  endsOn: string | null;
  humanStartsOn: string;
  humanEndsOn: string | null;
  categoryId: number;
  categoryName: string;
  categoryDiscarded: boolean;
  subcategoryId: number | null;
  subcategoryName: string | null;
  subcategoryDiscarded: boolean;
  assignedByName: string | null;
  current: boolean;
};

export interface PatientServiceAssignmentCreateForm {
  categoryId: number;
  subcategoryId?: number | null;
  startsOn?: string;
}

export interface PatientServiceAssignmentUpdateForm {
  startsOn?: string;
  endsOn?: string | null;
  patientServiceCategoryId?: number;
  patientServiceSubcategoryId?: number | null;
}

export const patientServiceAssignmentsApi = {
  index(patientId: number): Promise<Array<PatientServiceAssignment>> {
    return api({
      method: 'get',
      url: basePath(patientId),
    }).then(response => response.data.serviceAssignments);
  },
  create(
    patientId: number,
    form: PatientServiceAssignmentCreateForm,
  ): Promise<PatientServiceAssignment> {
    return api({
      method: 'post',
      url: basePath(patientId),
      data: { serviceAssignment: form },
    }).then(response => response.data.serviceAssignment);
  },
  update(
    patientId: number,
    id: number,
    form: PatientServiceAssignmentUpdateForm,
  ): Promise<PatientServiceAssignment> {
    return api({
      method: 'put',
      url: `${basePath(patientId)}/${id}`,
      data: { serviceAssignment: form },
    }).then(response => response.data.serviceAssignment);
  },
  destroy(patientId: number, id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${basePath(patientId)}/${id}`,
    }).then(() => {});
  },
};
